import { MonitorView } from "@/services/backend/qpm/monitors/types/monitor-view";
import {
  useQpmMonitorConsumablesEnrichedQuery,
  useQpmMonitorConsumablesOverrideMutation,
} from "@/services/backend/qpm/monitors/api/monitor-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { mapConsumablesEnrichedToDto } from "@/services/backend/qpm/lib/mappers/consumables";
import { ConsumableMaterialTable } from "./edit-monitor-consumable";

export function MonitorConsumablesComponent({
  monitor,
}: {
  monitor: MonitorView;
}) {
  const { data, isLoading, error } = useQpmMonitorConsumablesEnrichedQuery(
    { id: monitor.id },
    {
      // keep UI aligned when navigating between monitors
      refetchOnMountOrArgChange: true,
    },
  );

  const [updateOverride] = useQpmMonitorConsumablesOverrideMutation();

  if (isLoading) {
    return <ConsumableMaterialTable consumableList={[]} />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  const mapped = mapConsumablesEnrichedToDto(data?.items);

  return (
    <ConsumableMaterialTable
      consumableList={mapped}
      monitorId={monitor.id}
      onSaveOverride={async (req) => {
        await updateOverride(req).unwrap();
      }}
    />
  );
}
